import type { ReactElement } from 'react';

/** 구글 로그인 버튼의 "G" 심볼 — 브랜드 지침상 네 가지 고유 색을 그대로 쓰고 크기는 버튼이 정한다. 꾸밈이라 보조기기에서 감춘다. */
export const GoogleIcon = (): ReactElement => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path
      fill="#4285F4"
      d="M23.52 12.27c0-.85-.08-1.67-.22-2.45H12v4.64h6.46a5.52 5.52 0 0 1-2.4 3.62v3.01h3.88c2.27-2.09 3.58-5.17 3.58-8.82Z"
    />
    <path
      fill="#34A853"
      d="M12 24c3.24 0 5.96-1.07 7.94-2.91l-3.88-3.01c-1.07.72-2.45 1.15-4.06 1.15-3.12 0-5.77-2.11-6.71-4.94H1.27v3.1A12 12 0 0 0 12 24Z"
    />
    <path
      fill="#FBBC05"
      d="M5.29 14.29A7.2 7.2 0 0 1 4.91 12c0-.8.14-1.57.38-2.29V6.6H1.27A12 12 0 0 0 0 12c0 1.94.46 3.77 1.27 5.4l4.02-3.11Z"
    />
    <path
      fill="#EA4335"
      d="M12 4.77c1.76 0 3.34.61 4.59 1.8l3.44-3.44C17.95 1.19 15.23 0 12 0A12 12 0 0 0 1.27 6.6l4.02 3.11C6.23 6.88 8.88 4.77 12 4.77Z"
    />
  </svg>
);
